<template>
  <section class="data-table">
    <div class="container-fluid">

      <div class="row">
        <div class="col-12">
          <b-alert variant="danger" :show="!!error" @dismissed="error = false" dismissible>{{ error }}</b-alert>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <b-form-input class="search-input" @input="search" v-model="q" placeholder="Start typing to search across all text fields" size="lg"></b-form-input>

          <div v-if="loader" class="spinner-border float-right text-primary spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-12">
          <b-alert variant="info" :show="!!info" @dismissed="info = false" dismissible v-html="info">
          </b-alert>
        </div>
      </div>

      <div class="row" v-if="rowData.length">
        <div class="col-12">
          <ag-grid-vue domLayout='autoHeight'
                       class="ag-theme-balham"
                       :pagination="true"
                       :gridOptions="gridOptions"
                       @grid-ready="onGridReady"
                       @modelUpdated="onModelUpdated"
                       :frameworkComponents="frameworkComponents"
                       :columnDefs="columnDefs"
                       :defaultColDef="defaultColDef"
                       rowSelection="multiple"
                       :rowData="rowData">
          </ag-grid-vue>
        </div>
      </div>

    </div>
  </section>
</template>

<script>

import {AgGridVue} from "ag-grid-vue";

import EventBus from '../event-bus';

import API from '../api';

import _ from 'lodash';

const BASE_URL = 'https://elixir.ut.ee/eqtl';

import { encodeQueryString } from '../util.js';

export default {
  name: "LookUp",
  components: {
    AgGridVue
  },
  data() {
    return {
      q: "",
      info: null,
      error: null,
      loader: false,

      columns: [],
      rowData: [],
      gridApi: null,
      columnApi: null,
      frameworkComponents: null,

      defaultColDef: {
        resizable: true,
        sortable: true
      },
      gridOptions: {
        rowHeight: 20,
      },
      columnDefs: [
        {
          headerName: 'molecular trait id',
          field: 'molecular_trait_id',
          width: 150,
          minWidth: 150,
          cellRenderer: (params) => {
            let q = {};
            q[params.colDef.field] = params.value;

            let re = new RegExp(this.q, 'gi');
            let value = params.value.replace(re, function(match) {
              return '<strong class="highlight">' + match + '</strong>'
            });

            return `<a target="_blank" href="${BASE_URL}/${encodeQueryString(q)}">${value}</a>`
          },
        },
        {
          headerName: 'gene name',
          field: 'gene_name',
          width: 100,
          cellRenderer: (params) => {
            let q = {};
            q[params.colDef.field] = params.value;

            let re = new RegExp(this.q, 'gi');
            let value = params.value.replace(re, function(match) {
              return '<strong class="highlight">' + match + '</strong>'
            });

            return `<a target="_blank" href="${BASE_URL}/${encodeQueryString(q)}">${value}</a>`
          },
        },
        {
          headerName: 'credible set',
          field: 'credible_set',
          width: 180,
          cellRenderer: (params) => {
            let q = {};
            q[params.colDef.field] = params.value;

            let re = new RegExp(this.q, 'gi');
            let value = params.value.replace(re, function(match) {
              return '<strong class="highlight">' + match + '</strong>'
            });

            return `<a target="_blank" href="${BASE_URL}/${encodeQueryString(q)}">${value}</a>`
          },
        },
        {
          headerName: 'variant',
          field: 'variant',
          width: 180,
          cellRenderer: (params) => {
            let q = {};
            q[params.colDef.field] = params.value;

            let re = new RegExp(this.q, 'gi');
            let value = params.value.replace(re, function(match) {
              return '<strong class="highlight">' + match + '</strong>'
            });

            return `<a target="_blank" href="${BASE_URL}/${encodeQueryString(q)}">${value}</a>`
          },
        },
        {
          headerName: 'rs id',
          field: 'rsid',
          width: 100,
          cellRenderer: (params) => {
            let q = {};
            q[params.colDef.field] = params.value;

            let re = new RegExp(this.q, 'gi');
            let value = params.value.replace(re, function(match) {
              return '<strong class="highlight">' + match + '</strong>'
            });

            return `<a target="_blank" href="${BASE_URL}/${encodeQueryString(q)}">${value}</a>`
          },
        },
        {
          headerName: 'credible set size',
          field: 'credible_set_size',
          width: 50,
        },
        {
          headerName: 'pip',
          field: 'pip',
          width: 100,
        },
        {
          headerName: 'p value',
          field: 'pvalue',
          width: 100,
        },
        {
          headerName: 'beta',
          field: 'beta',
          width: 100,
        },
        {
          headerName: 'se',
          field: 'se',
          width: 100,
        },
        {
          headerName: 'dataset',
          field: 'dataset',
          width: 150,
          cellRenderer: (params) => {
            let q = {};
            q[params.colDef.field] = params.value;

            let re = new RegExp(this.q, 'gi');
            let value = params.value.replace(re, function(match) {
              return '<strong class="highlight">' + match + '</strong>'
            });

            return `<a target="_blank" href="${BASE_URL}/${encodeQueryString(q)}">${value}</a>`
          },
        }
      ],
    }
  },
  mounted() {
    window.addEventListener("resize", _.throttle(()=>{
      this.onModelUpdated();
    }), 300);
  },
  methods: {
    search: _.debounce(function() {
      this.loader = true;
      this._search();
    }, 500),

    _search() {
      API.search(this.q, json=>{
        this.rowData = json.page;

        if (!json.n) {
          this.info = `No records have been found by the query: <strong>${json.q}</strong>.`;
        } else {
          this.info = null;
        }

        console.log(this.rowData);

        this.loader = false;
      });
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.sizeColumnsToFit();
    },
    onModelUpdated() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
  }
}
</script>

<style scoped>
.spinner {
  position: absolute;
  top: 8px;
  right: 28px;
}
.search-input {
  padding-right: 50px;
}

</style>

<style>
.highlight {
  background-color: coral;
  color: white;
}
</style>
